import { DataService } from '../../../services/data_service';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface DatenverwaltungGtzOrteProps {
    data: any;
}

export class DatenverwaltungGtzOrte extends React.Component<DatenverwaltungGtzOrteProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private start: number = 2010;
    private end: number = Moment().year() - 1;

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_GTZ_ORTE}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                externalHeaderElements={this.getHeaderElements()}
                onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_GTZ_ORTE)}
                showColumnsHelp
            />
        );
    }

    getHeaderElements(): Array<JSX.Element> {
        return [
            <WActionButton
                label='Daten prüfen'
                insideText='Daten prüfen'
                tooltip={`Daten [${this.start} - ${this.end}] auf Vollständigkeit prüfen & markieren`}
                key='save'
                action='save'
                onAction={() => confirm(`Orte mit unvollständigen Daten [${this.start} - ${this.end}] markieren?`)
                    ? this.validateData()
                    : null
                }
            />
        ];
    }

    validateData(): void {
        this.dataService.loadData(
            IDs.ENT_GTZ, {}, {}, (obj: any, entity: string) => {
                const gtz_orte: Array<any> = [];
                const orte: any = {};
                const values: number = (this.end - this.start + 1) * 12;

                (obj[entity] || []).forEach((gtz: any) => {
                    const ort_tid: number = +gtz.ort_tid || null;
                    const jahr: number = +gtz.jahr || 0;
                    const monat: number = +gtz.monat || 0;

                    if (typeof orte[ort_tid] === 'undefined') {
                        orte[ort_tid] = {};
                    }

                    if ((jahr >= this.start && jahr <= this.end) && (monat >= 1 && monat <= 12)) {
                        orte[ort_tid][`${jahr}${monat}`] = true;
                    }
                });

                (this.props.data[IDs.ENT_GTZ_ORTE] || []).forEach((ort: any) => {
                    const tid: number = +ort.tid || null;
                    gtz_orte.push({ tid, ungueltig: Object.keys(orte[tid] || {}).length !== values ? 1 : 0 });
                });
                this.dataService.saveDataList(
                    IDs.ENT_GTZ_ORTE, gtz_orte,
                    () => this.triggerService.fire('reload', IDs.ENT_GTZ_ORTE),
                    IDs.MOD_ETOOL_ADMIN
                );
            },
            IDs.MOD_ETOOL_ADMIN
        );
    }
}
